export function groupChatReadStatus(data) {
    // let isReadMail = selectedGroupData && selectedGroupData?.userList.find(user => user.creatorId === selectedGroupData.userId).isReadUnread;
    // return data.UserList.find(user => user.userId === data.creatorId)?.isReadUnread || null;
    return data && data.userList.find(user => user.userId === data.creatorId)?.isReadUnread;
}
  